import { useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api';

export function Login() {
  const qc = useQueryClient();
  const [email, setEmail] = useState(''); const [password, setPassword] = useState(''); const [err, setErr] = useState<string | null>(null); const [busy, setBusy] = useState(false);
  const submit = async (e: React.FormEvent) => {
    e.preventDefault(); setBusy(true); setErr(null);
    try { await api.post('/api/auth/login', { email, password }); await qc.invalidateQueries({ queryKey: ['me'] }); window.location.href = '/'; }
    catch (x) { setErr((x as Error).message); } finally { setBusy(false); }
  };
  return (
    <div className="login">
      <div className="login-art">
        <div className="row" style={{ color: '#fff', fontWeight: 640 }}><div className="brand-mark">CI</div>Construction Intelligence</div>
        <div>
          <h1>One connected record of what was contracted, planned, built, earned and still at risk.</h1>
          <p style={{ maxWidth: 520, color: '#9fb0c6', marginTop: 14 }}>Pre-planning, readiness, sequencing, field execution, workforce, compliance and project controls — every fact linked to its source and its consequences.</p>
        </div>
        <div className="small" style={{ color: '#6f819a' }}>Authorized users only. Activity is recorded in the project audit trail.</div>
      </div>
      <div className="login-form">
        <form onSubmit={submit} aria-label="Sign in">
          <h1>Sign in</h1>
          <label className="field">Email<input type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} required /></label>
          <label className="field">Password<input type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required /></label>
          {err && <div className="banner crit">{err}</div>}
          <button className="btn primary" disabled={busy} style={{ justifyContent: 'center', padding: '9px 12px' }}>{busy ? 'Signing in…' : 'Sign in'}</button>
        </form>
      </div>
    </div>
  );
}
